/* @jsx h */
import { defineComponent, h } from "vue";

export const NoDevices = defineComponent({
  name: "NoDevices",
  setup() {
    return () => (
      <div class="h-full flex flex-col items-center justify-center text-center p-8">
        <div class="text-6xl mb-4">
          <i class="ri-device-line"></i>
        </div>
        <h1 class="text-2xl font-bold text-accent mb-2">No Devices Found</h1>
        <p class=" max-w-md">
          There are no printers or payment terminals configured for this
          restaurant. Contact support to add new devices.
        </p>
        <a
          href="#"
          class="mt-4 text-blue-400 hover:text-blue-300 flex items-center gap-1"
        >
          Learn more about device setup
          <i class="ri-external-link-line"></i>
        </a>
      </div>
    );
  },
});
